import axiosInstance from './axiosInstance';

export const GetPartById = async (part_id) => {
  try {
    const { data } = await axiosInstance.get(`/Part/Data/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetLastCSIPart = async (type) => {
  try {
    const { data } = await axiosInstance.get(`/Part/LastCSI/${type}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPartInvById = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/Data/${store_id}/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetApprovedPartById = async (part_id) => {
  try {
    const { data } = await axiosInstance.get(`/ApprovedPart/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPartHistoryById = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/Inventory/History/${part_id}`, { params: { storeId: store_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const DelPart = async (part_id) => {
  try {
    const { data } = await axiosInstance.delete(`/Part/${part_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const getPartsByFilter = async (company_id, category_id) => {
  try {
    const { data } = await axiosInstance.get(`/Part/data`, { params: { companyId: company_id ?? undefined, categoryId: category_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getAppPartsByFilter = async (company_id, category_id) => {
  try {
    const { data } = await axiosInstance.get(`/Part/MfgData`, { params: { companyId: company_id ?? undefined, categoryId: category_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getInvPartsByFilter = async (store_id, company_id, category_id) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/data/${store_id}`, {
      params: { companyId: company_id ?? undefined, categoryId: category_id ?? undefined },
    });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getPartsListByStoreFilter = async (store_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/List/${store_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getPartListByCompanyFilter = async (company_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/part/List/${company_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getPartDataListByCompFilter = async (company_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/part/DataList/${company_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getPartDataListByStoreFilter = async (store_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/DataList/${store_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getPartDataListByCompStoreFilter = async (company_id, store_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/DataList/${company_id}/${store_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetopeningBal = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/inventory/${store_id}/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddApprovedPartsApi = async (part_id, mfg_pn, mfg_name,) => {
  try {
    const { data } = await axiosInstance.put(`/ApprovedPart`, { part_id: part_id, mfg_names: mfg_name, mfg_pns: mfg_pn });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddPartApi = async (category_id, s_category_id, description, unit_id, location, cost_price, sale_price, mark_up, serialized, pn_status_id, company_id, image, pn_note, user_id) => {
  try {
    const { data } = await axiosInstance.post(`/Part`, {
      part_number: "",
      category_id: category_id,
      s_category_id: s_category_id,
      description: description,
      quantity: 0,
      unit_id: unit_id,
      stockroom_location: location,
      cost_price: cost_price,
      sale_price: sale_price,
      mark_up: mark_up,
      low_stock: 0,
      serialized: serialized,
      pn_status_id: pn_status_id,
      image: image,
      nonpart: false,
      company_id: company_id,
      pn_note: pn_note,
      user_id: user_id
    });
    return data;
  } catch (err) {
    console.error(err);
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditPartApi = async (part_id, category_id, s_category_id, description, unit_id, location, cost_price, sale_price, mark_up, serialized, pn_status_id, company_id, image, pn_note, reason, reason_note, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/Part/${part_id}`, {
      part_number: "",
      category_id: category_id,
      s_category_id: s_category_id,
      description: description,
      quantity: 0,
      unit_id: unit_id,
      stockroom_location: location,
      cost_price: cost_price,
      sale_price: sale_price,
      mark_up: mark_up,
      low_stock: 0,
      serialized: serialized,
      pn_status_id: pn_status_id,
      image: image,
      nonpart: false,
      company_id: company_id,
      pn_note: pn_note,
      reason: reason,
      reason_note: reason_note,
      user_id: user_id
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
